<template>
  <transition name="fade" mode="out-in">
    <div>
      <link
        rel="stylesheet"
        v-if="identidadeVisual.css"
        :href="identidadeVisual.css"
      />

      <router-view></router-view>
    </div>
  </transition>
</template>

<script>
import * as Sentry from "@sentry/vue";
import { mapActions, mapState } from "vuex";
import TipoUsuarioEnum from "~/domain/prova/TipoUsuarioEnum";

export default {
  name: "App",
  data() {
    return {
      defaultApplication: "applicado"
    };
  },
  computed: {
    applicationName() {
      let name = "Provas";

      if (this.identidadeVisual) {
        name = this.identidadeVisual.name;
      }

      return name;
    },
    identidadesDisponiveis() {
      let visuais = [];

      for (const visual in this.identidadesVisuais) {
        visuais = [...visuais, visual];
      }

      return visuais;
    },
    application() {
      let [domain] = window.location.hostname.split(".");

      return this.identidadesDisponiveis.indexOf(domain) != -1
        ? domain
        : this.defaultApplication;
    },
    identidadeAtual() {
      return this.identidadesVisuais[this.application];
    },
    ...mapState(["identidadeVisual", "identidadesVisuais", "usuario"])
  },
  watch: {
    $route(to, from) {
      let title = to.meta.title;
      document.title = title
        ? `${title} - ${this.applicationName} - Grupo Integrado`
        : `${this.applicationName} - Grupo Integrado`;
    },
    identidadeAtual: {
      deep: true,
      immediate: true,
      handler: function(val, oldVal) {
        if (val != oldVal) {
          this.setIdentidadeVisual(val);
        }
      }
    }
  },
  sockets: {
    Started(data) {
      try {
        if (
          this.$route.name != "Monitoramento de Provas" &&
          data
        ) {
          // Descomentar quando subir para produção, validação para não ficar salvando no state quando for um aluno, só precisa salvar quando for professores
          let liberado = true;
          if (this.usuario.perfis && this.usuario.perfis.length > 0) {
            for (const perfis of this.usuario.perfis) {
              if (perfis.tipoId == TipoUsuarioEnum.ALUNO) {
                liberado = false;
              }
            }
          }
          if (liberado)
            this.$store.dispatch("monitorAlunos/setListAlunos", data);
          this.$store.dispatch("monitorAlunos/setListAlunos", data);
        }
      } catch (err) {
        throw err;
      }
    }
  },
  methods: {
    ...mapActions(["setIdentidadeVisual", "menu/toogleMenu"])
  },
  mounted() {
    const { id, login } = this.usuario;
    Sentry.setUser({
      id,
      username: login
    });
  }
};
</script>

<style>
.pagina-enter-active,
.pagina-leave-active {
  transition: opacity 0.3s;
}

.pagina-enter,
.pagina-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue